import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {MesoAdsContextOnPDP} from '@homeaway/react-meso-ads';
import getMesoContext from '../../selectors/mesoContext';

const mapStateToProps = (state) => getMesoContext(state);

@connect(mapStateToProps)
class MesoAdsContextProvider extends Component {
    static propTypes = {
        havId: PropTypes.string.isRequired,
        gaiaId: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        brandId: PropTypes.string.isRequired,
        brandName: PropTypes.string.isRequired,
        details: PropTypes.shape({
            adults: PropTypes.number,
            children: PropTypes.number,
            arriveDate: PropTypes.string,
            departDate: PropTypes.string
        })
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {children, ...rest} = this.props;

        return <MesoAdsContextOnPDP {...rest}>{children}</MesoAdsContextOnPDP>;
    }
}

export default MesoAdsContextProvider;
